<template>
  <v-dialog v-model="openDialog" persistent max-width="600px">
    <v-card>
      <v-card-title class="text-h5">
        <v-icon class="mr-2">mdi-web</v-icon>
        Veranstaltungsseite
      </v-card-title>

      <v-card-text>
        <div v-if="loading" class="text-center pa-4">
          <v-progress-circular indeterminate color="primary" />
        </div>

        <div v-else-if="existingPage">
          <v-alert type="success" outlined class="mb-4">
            Veröffentlicht als
            <strong>{{ existingPage.name }}.html</strong>
          </v-alert>
          <div class="mb-2">
            <strong>URL:</strong>
            <a :href="existingPage.url" target="_blank">{{
              existingPage.url
            }}</a>
          </div>
          <div class="text-caption grey--text">
            Veröffentlicht am
            {{ new Date(existingPage.publishedAt).toLocaleDateString("de-DE") }}
          </div>
        </div>

        <div v-else>
          <p class="mb-4">
            Geben Sie einen Dateinamen ein. Die Seite wird auf
            veranstaltung.iqib.de veröffentlicht.
          </p>
          <v-text-field
            v-model="pageName"
            label="Seitenname"
            hint="z.B. innovationtalk_05_2026 (ohne .html)"
            persistent-hint
            :rules="nameRules"
            outlined
            dense
          />
          <div v-if="pageName" class="text-caption mt-1">
            URL: https://veranstaltung.iqib.de/{{ pageName }}.html
          </div>
        </div>

        <v-alert v-if="error" type="error" outlined class="mt-4">
          {{ error }}
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn outlined @click="closeDialog">Schließen</v-btn>
        <v-btn
          v-if="existingPage"
          color="red"
          dark
          :loading="actionLoading"
          @click="unpublish"
        >
          Seite entfernen
        </v-btn>
        <v-btn
          v-else-if="!loading"
          color="primary"
          :loading="actionLoading"
          :disabled="!isNameValid"
          @click="publish"
        >
          Veröffentlichen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiPublisherService from "@/services/api/ApiPublisherService";

export default {
  props: {
    open: { type: Boolean, default: false },
    event: { type: Object, default: null },
  },
  data() {
    return {
      pageName: "",
      loading: false,
      actionLoading: false,
      error: null,
      existingPage: null,
      nameRules: [
        (v) => !!v || "Name ist erforderlich",
        (v) =>
          /^[a-zA-Z0-9_-]+$/.test(v) ||
          "Nur Buchstaben, Zahlen, - und _ erlaubt",
        (v) => (v && v.length <= 100) || "Maximal 100 Zeichen",
      ],
    };
  },
  computed: {
    openDialog: {
      get() {
        return this.open;
      },
      set() {
        this.closeDialog();
      },
    },
    isNameValid() {
      return (
        this.pageName &&
        /^[a-zA-Z0-9_-]+$/.test(this.pageName) &&
        this.pageName.length <= 100
      );
    },
  },
  watch: {
    open(val) {
      if (val && this.event) {
        this.fetchPages();
      }
    },
  },
  methods: {
    closeDialog() {
      this.error = null;
      this.pageName = "";
      this.existingPage = null;
      this.$emit("close");
    },
    async fetchPages() {
      this.loading = true;
      this.error = null;
      try {
        const response = await ApiPublisherService.getPages();
        const pages = response.data;
        this.existingPage =
          pages.find((p) => p.eventId === this.event.id) || null;
      } catch (err) {
        this.error = "Seiten konnten nicht geladen werden.";
      } finally {
        this.loading = false;
      }
    },
    async publish() {
      this.actionLoading = true;
      this.error = null;
      try {
        const response = await ApiPublisherService.publishPage(
          this.pageName,
          this.event.id
        );
        this.existingPage = response.data;
      } catch (err) {
        this.error =
          err.response?.data?.error || "Veröffentlichung fehlgeschlagen.";
      } finally {
        this.actionLoading = false;
      }
    },
    async unpublish() {
      this.actionLoading = true;
      this.error = null;
      try {
        await ApiPublisherService.unpublishPage(this.existingPage.name);
        this.existingPage = null;
      } catch (err) {
        this.error = err.response?.data?.error || "Entfernen fehlgeschlagen.";
      } finally {
        this.actionLoading = false;
      }
    },
  },
};
</script>
